/**
 * Mini App: тот же бандл /app/prematch?from=tg.
 * Сессию шлюза не дублируем — initData уже обрабатывает access.
 */

type TgWebApp = {
  ready?: () => void;
  expand?: () => void;
  isExpanded?: boolean;
  initData?: string;
  MainButton?: {
    setText: (t: string) => void;
    show: () => void;
    hide: () => void;
    onClick: (fn: () => void) => void;
    offClick: (fn: () => void) => void;
  };
  openLink?: (url: string, opts?: { try_instant_view?: boolean }) => void;
};

export function tgApp(): TgWebApp | null {
  return (window as unknown as { Telegram?: { WebApp?: TgWebApp } }).Telegram?.WebApp ?? null;
}

export function fromTelegram(): boolean {
  if (tgApp() !== null) return true;
  try {
    return new URLSearchParams(location.search).get('from') === 'tg';
  } catch {
    return false;
  }
}

export function bootTelegram(): void {
  const app = tgApp();
  if (app === null) return;
  app.ready?.();
  app.expand?.();
}

export function openBookLink(url: string): boolean {
  const app = tgApp();
  if (app?.openLink) {
    app.openLink(url, { try_instant_view: false });
    return true;
  }
  const win = window.open(url, '_blank');
  return win != null;
}
